import produce from 'immer'
import { GraphState } from '../../model/monitoringGraph/types';
import { getEventsActionType, getMonitoringGraphActionType, getMonitoringPathActionType, MonitoringGraphActionTypes, updateMonitoringGraphActionType, updateMonitoringPathActionType
} from '../../model/monitoringGraph/actions';

const initialGraphState = {
      numberOfConversations:0,
        exist: true,
        availableActions : [],
        conversationsId : [],
        links: []
}

const initialState: GraphState = {
    events : [],
    graph: initialGraphState,
    path: initialGraphState
}

export function monitoringGraphReducer(
    state = initialState,
    action: MonitoringGraphActionTypes,
): GraphState {
    switch (action.type) {
        case getMonitoringGraphActionType.success:
            return produce(state, draftState => {
                draftState.graph= action.payload
            })
        case getMonitoringGraphActionType.failure:
            return produce(state, draftState => {
                draftState.graph = initialState.graph
            })
        case getMonitoringPathActionType.success:
            return produce(state, draftState => {
                draftState.path = action.payload
            })
        case getMonitoringPathActionType.failure:
            return produce(state, draftState => {
                draftState.path = initialState.path
            })
        case updateMonitoringGraphActionType.request:
            return produce(state, draftState => {
                draftState.graph = Object.assign(state.graph,action.payload)
            })
        case updateMonitoringPathActionType.request:
            return produce(state, draftState => {
                draftState.path = Object.assign(state.path,action.payload)
            })
        case getEventsActionType.success:
            return produce(state,draftSate => {
                draftSate.events = action.payload
            })
        case getEventsActionType.failure:
            return produce(state,draftState => {
                draftState.events = initialState.events;
            })
        default:
            return state
    }
}
